<template>
  <header>
      <div class="wrapper_1" @click="gotoIndex">
        <img style="vertical-align: middle; padding-bottom: 6px; width: 44px; height: 32px; margin-left: 16px;" src="/static/images/favicon.png">
        <span class="logo_title">大模型服务平台</span>
      </div>
      <div class="wrapper_2">
      </div>

      <div class="wrapper_3">
        <div class="right_menu">
<!--          <div style="margin-right: 8px;" class="link" @click="gotoMyCourse">控制台</div>-->
          <div class="login_info_wrapper" v-if="isLogin">
            <div class="login_info" @click="gotoCustomerCenter">
              <el-avatar style="margin-top: 7px; margin-right: 8px;" size="medium" src="/static/images/avatar.png"></el-avatar>
              <div class="link" >{{phone2}}</div>
            </div>

            <div class="link" @click="logout">退出</div>
          </div>
          <div v-else class="link" @click="gotoLogin">登录</div>
        </div>
      </div>
  </header>
</template>

<script>
import { removeLoginPhone, removeToken, removeUUID } from '@/common/auth'
import {mapState, mapGetters} from 'vuex'
import {
  reqLogout
} from '@/api'

export default {
  name: 'Header',
  data() {
    return {
    }
  },

  // 接收父组件的值
  props: {
    loginSource: Number,
    required: true
  },

  methods: {
    // 跳转到登录页面
    gotoLogin () {
      const loginSource = this.loginSource
      this.$store.dispatch('setLoginSource', {loginSource})
      this.$router.push('/login')
    },

    gotoIndex () {
      this.$router.replace('/').catch(err => {})
    },

    gotoMyCourse () {
      this.$router.push({
        path: '/coursePlayInfo'
      }).catch(err=>{})
    },

    gotoCustomerCenter () {
      // 打开新的页面
      let {href} = this.$router.resolve(
        {
          path: '/customerCenter',
          query: {}
        }
      )
      window.open(href, '_blank')
    },

    logout () {
      this.$confirm('确定退出系统吗', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await reqLogout()

        removeToken()
        removeUUID()
        removeLoginPhone()

        const phone = ''
        await this.$store.dispatch('setPhone', {phone})
        const token = ''
        await this.$store.dispatch('setToken', {token})
        await this.$router.replace('/login')
      }).catch(() => {
      })
    },
  },

  computed: {
    ...mapState(['phone']),
    ...mapGetters(['isLogin']),

    phone2 () {
      return this.phone.substr(0, 3) + '****' + this.phone.substr(7)
    },

  }
}
</script>

<style scoped>
  header {
    width: 100%;
    height: 50px;
    background-color: rgba(242, 242, 247, 0.8);
    display: flex;
    justify-content: space-between;
    /*margin-bottom: 2px;*/
  }

  .wrapper_1 {
    /*border: 1px solid red;*/
    display: block;
    width: 218px;
    height: 50px;
    line-height: 50px;
    text-align: left;
    cursor: pointer;
  }

  .wrapper_2 {
    /*border: 1px solid black;*/
    display: flex;
    justify-content: space-between;
    width: 1000px;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
  }

  .wrapper_3 {
    /*border: 1px solid red;*/
    display: flex;
    justify-content: flex-end;
    width: 218px;
    text-align: center;
    height: 50px;
    line-height: 50px;
    font-size: 14px;
    color: rgba(0, 0, 0, 0.7);
    padding-right: 10px;
  }

  /*.wrapper_3 {*/
  /*  border: 1px solid red;*/
  /*  display: block;*/
  /*  width: 218px;*/
  /*  text-align: right;*/
  /*  height: 50px;*/
  /*  line-height: 50px;*/
  /*}*/

  .login_info_wrapper {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
  }

  .login_info {
    display: flex;
    justify-content: space-between;
    margin-right: 6px;
  }

  .right_menu {
    display: flex;
    justify-content: space-between;
  }

  .link {
    cursor: pointer;
    margin-right: 12px;
  }

  .link:hover {
    color: #FF9900;
  }

  a {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.6);
  }

  a:hover {
    color: #FF9900;
  }

  .logo_title {
    text-align: left;
    font-size: 20px;
    color: #333;
    font-weight: bold;
    font-family: Arial, sans-serif;
    height: 50px;
    line-height: 50px;
  }

</style>



// WEBPACK FOOTER //
// src/components/Header.vue